<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
    </customize-page>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import b2bApi from "@/api/b2b";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      itemMap: {},
      stockoutGoods: [],
      columns: [
        {
          type: "expand",
          render: (h, params) => {
            if (!this.itemMap[params.row.id]) {
              b2bApi
                .load({
                  toBStockoutOrderId: params.row.id,
                })
                .then((res) => {
                  this.itemMap[params.row.id] = res.items;
                  this.itemMap = { ...this.itemMap };
                });
            }
            return (
              <el-table
                border
                style="width: 100%"
                data={this.itemMap[params.row.id]}
              >
                <el-table-column
                  align="center"
                  prop="skuName"
                  label="商品名称"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="barcode"
                  label="商品条码"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="planStockoutQuantity"
                  label="计划出库数量"
                  width="150"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="actualStockoutQuantity"
                  label="实际出库数量"
                  width="150"
                ></el-table-column>
              </el-table>
            );
          },
        },
        {
          title: "外部订单号",
          key: "outBizId",
          align: "center",
          width: 200,
        },
        {
          title: "出库单类型",
          key: "type",
          align: "center",
          render: (h, params) => {
            const typeMap = {
              STOCKOUT: "B端出库",
            };

            return <span>{typeMap[params.row.type]}</span>;
          },
        },
        {
          title: "申报状态",
          key: "declareState",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              WAIT_DECLARE: ["info", "待申报"],
              DECLARE_FAIL: ["error", "申报失败"],
              DECLARE_SUCCESS: ["success", "申报成功"],
            };
            return (
              <div>
                <el-tag type={tagType[row.declareState][0]}>
                  {tagType[row.declareState][1]}
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "出库状态",
          key: "state",
          align: "center",
          render: (h, params) => {
            const tagType = {
              WAIT_STOCKOUT: ["info", "待出库"],
              STOCKOUTING: ["warning", "出库中"],
              CANCELED: ["info", "已取消"],
              SHIPPED: ["success", "已出库"],
            };
            return (
              <div>
                <el-tag type={tagType[params.row.state][0]}>
                  {tagType[params.row.state][1]}
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "推送wms状态",
          width: 200,
          key: "wmsState",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              INIT: ["info", "待推送"],
              WMS_CREATE_SUCCESS: ["success", "推送仓库成功"],
              START_TALLY: ["success", "开始理货"],
              TALLY_FINISHED: ["success", "理货完成"],
              WMS_CREATE_EXCEPTION: ["error", "推送仓库异常"],
              STOCKOUT_FINISHED: ["success", "出库完成"],
              CANCELED: ["info", "已取消"],
            };
            return (
              <div>
                <el-tag type={tagType[row.wmsState][0]}>
                  {tagType[row.wmsState][1]}
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "发货时间",
          key: "gmtShip",
          align: "center",
          width: 200,
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          align: "center",
          width: 200,
        },
      ],
      filterObj: {
        customerId: "",
        outBizId: "",
        wmsState: "",
        state: "",
        palletState: "",
      },
      currentRow: [],
      dialogVisible: false,
      editRow: {},
    };
  },
  methods: {
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      let searchCondition = {
        request: {
          ...filterParams,
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      };
      b2bApi
        .pageQuery(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          this.itemMap = {};
          this.pagination.currentPage = res.page.pageIndex;
          this.pagination.pageSize = res.page.pageSize;
          this.pagination.totalCount = res.page.totalCount;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "外部订单号",
              model: "outBizId",
              type: type.INPUT,
            },
            {
              label: "仓库状态",
              model: "wmsState",
              type: type.SELECT,
              props: {
                data: [
                  { value: "INIT", label: "初始化" },
                  { value: "WMS_CREATE_SUCCESS", label: "已下发" },
                  { value: "WMS_CREATE_EXCEPTION", label: "下发异常" },
                ],
              },
            },
            {
              label: "出库单状态",
              model: "state",
              type: type.SELECT,
              props: {
                data: [
                  { value: "WAIT_STOCKOUT", label: "待出库" },
                  { value: "STOCKOUTING", label: "出库中" },
                  { value: "SHIPPED", label: "已出库" },
                  { value: "CANCELED", label: "已取消" },
                ],
              },
            },
          ],
        },
      ];
    },
  },
};
</script>
